import env from "app/utils/env";
import { FETCH_LOOKALIKE_PRODUCTS } from "app/pages/.shared/LookAlikeProduct/lookAlikeProductActionTypes";
import axios from "app/utils/http/http";

export const fetchLookAlikeProducts = id => {
	return {
		type: FETCH_LOOKALIKE_PRODUCTS,
		promise: axios.get(`${env("NAV_LOGS_API_URL")}/reco?id=${id}`, {
			"Content-type": "application/json",
		}),
	};
};
